import { License, LicenseAction } from "../interfaces/global-interfaces";

export default function getLicenseAction(licenses: any){
    return {
        type: LicenseAction.Update,
        payload: licenses
    } as License
}